import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetCannedResponses(
    $partnerId: ID!
    $prefix: String!
    $first: Int
    $after: String
  ) {
    partner(id: $partnerId) {
      id
      cannedResponses(prefix: $prefix, first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            command
            response
            isCreatedByMe
          }
        }
      }
    }
  }
`);
